<template>
  <div id="app" v-wechat-title='$route.meta.title'>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
.body {
  line-height: 0 !important;
}

.v_mainBox {
  width: 95%;
  height: auto;
  display: block;
  overflow: hidden;
  margin: auto;
  /*padding-top: 50px;*/
}

.van-nav-bar .van-icon {
  color: #333 !important;
}

/*代驾检车*/
.van-dropdown-menu__item {
  flex: inherit !important;
}

.van-dropdown-menu__title {
  padding-right: 3px !important;
  padding-left: 0 !important;
}

.van-dropdown-menu__bar {
  height: 45px !important;
  box-shadow: none;
}

.van-dropdown-menu__bar--opened {
  z-index: 0 !important;
}

.van-dropdown-menu__title::after {
  right: -5% !important;
}

.van-cell__right-icon {
  height: 45px !important;
  line-height: 45px !important;
  padding-right: 15px
}

.van-field__label {
  padding-left: 20px;
  margin-right: 0 !important;
  color: #333 !important;
}

.van-field__control {
  padding-right: 10px
}

/*下拉列表*/
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
  border: none !important;
}

.van-cell {
  height: 45px !important;
  line-height: 45px !important;
  padding: 0 10px !important;
  margin: 0 !important;
}
.van-marg{margin:9px 15px}
.van-button{border-radius: 10px!important;}
/*日期*/
.van-picker__toolbar {
  border-bottom: 1px solid #ccc;
}

/*预约历史列表*/
.van-collapse-item__content {
  padding: 0 15px !important;
}

/*检车页面tabar*/
.van-tabs__content {
  border-top: 1px solid #eee;
}

/*底部导航*/
.van-tabbar--fixed {
  border-top: 1px solid #eee;
}

/*地址图标*/
.address-icon {
  font-size: 18px;
  color: #3778d0;
  display: inline-block;
}

.van-tabs__line {
  background-color: #3778d0 !important;
}

.van-tabbar-item--active {
  color: #3778d0 !important;
}

/*评论*/
.box p {
  padding: 0;
  margin: 0
}

.van-pl p {
  color: #333;
}

.van-pl .van-plTitle {
  width: 100%;
  height: auto;
  display: block;
  margin-bottom: 10px;
}

.van-pl .van-plTitle .p_one {
  width: 100%;
  height: 40px;
  line-height: 50px;
  margin-top: 10px;
}

.van-pl .van-plTitle .p_one .span-img {
  display: block;
  height: 30px;
  width: 30px;
  margin-top: 7px;
  float: left;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px
}

.van-pl .van-plTitle .van-cData {
  font-size: 12px;
  color: #888;
}

.van-padding {
  padding-left: 12% !important;
}

.van-pl .van-plTitle .p_one .span1 {
  font-size: 16px;
  font-weight: bold;
  padding-right: 5%;
}

.van-pl .van-plTitle .p_one .span2 {
  color: #3778d0;
  font-size: 13px;
}

.van-pl .van-inforT {
  width: 100%;
  height: auto;
}

.van-pl .van-inforT p {
  white-space: initial;
  font-size: 13px;
  line-height: 22px;
}

.van-pl .van-inforImg {
  width: 100%;
  height: auto;
  display: block;
  margin: 10px 0;
  overflow: hidden;
}

.van-pl .van-inforImg span {
  width: 30%;
  height: 90px;
  display: block;
  overflow: hidden;
  float: left;
  padding-right: 1%;
}

.van-pl .van-inforImg span img {
  width: 100%;
  height: 100%;
}

.van-pl .van-kf {
  width: 100%;
  height: auto;
  display: block;
  overflow: hidden;
  padding-bottom: 15px;
}

.van-pl .van-kf .van-titleH {
  width: 100%;
  height: 30px;
  line-height: 35px;
  color: #888;
  font-size: 14px;
}

.van-pl .van-kf .van-hf {
  white-space: initial;
  font-size: 13px;
  color: #888;
}

.van-ellipsis {
  color: #3778d0;
  font-size: 14px !important;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.van-switch {
  margin-top: 11px;
}


.van-addressBox a {
  color: #3778d0;
}

.van-nav-bar__title {
  color: #3778d0 !important;
  font-weight: 600 !important;
}

.van-uploader__input {
  z-index: 5 !important;
}

.van-button--info {
  background-color: #3778d0!important;
  border-color: #3778d0!important;
   border: 1px solid #3778d0!important;
}

.van-nav-bar--fixed {
  z-index: 10 !important;
}

.van-botton {
  width: 100%;
  height: 60px;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 100;
}

.van-mar {
  margin-bottom: 65px
}

.van-uploader__preview-image {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden
}
</style>
